// extracted by mini-css-extract-plugin
module.exports = {"statisticsPanel":"moduleStatistics_statisticsPanel__2txv-"};